import IncrementalText from "./incrementalText";

export default IncrementalText;